import React from 'react'
import { createContext } from 'react'
import PropTypes from 'prop-types'

export const ReadOnlyContext = createContext({ readOnly: false })

const ReadOnlyProvider = ({ readOnly, children }) => {
  return (
    <ReadOnlyContext.Provider value={{ readOnly }}>
      {children}
    </ReadOnlyContext.Provider>
  )
}

ReadOnlyProvider.propTypes = {
  readOnly: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default ReadOnlyProvider
